<div class="orderBoard">
    <div class="title" onclick="getOrders()">
        <h2>Pedidos</h2>
    </div>

    <div class="orderTitle" *ngFor="let order of orders">
        <p>ID: {{order.id}}</p>
        <p>Produto: {{order.Product}}</p>
        <p>Quantidade: {{order.Quantidade}}</p>
        <hr>
    </div>
</div>
